'use es6';

import { isEmpty, isObject } from 'underscore';
import addDefaultConsentCopy from 'SharedLegalStrings/consent/addDefaultConsentCopy';
import { CONSENT_FIELDS } from 'SharedLegalStrings/consent/constants';
import { fetchSubscriptionDefinitionsByBusinessUnitId } from 'FormsCommonComponents/api/LegalConsent';
import { getSubscriptionDefinitions as getSubscriptionDefinitionsFromSelector } from 'FormsCommonComponents/selectors/LegalConsent';
import { ACCOUNT_BUSINESS_UNIT_ID } from 'FormsCommonComponents/constants/BusinessUnits';
export function _parseValuesFromConsentCopy(consentCopy) {
  return Object.keys(consentCopy).reduce((memo, key) => {
    const unparsedCopy = consentCopy[key];
    memo[key] = CONSENT_FIELDS.reduce((copy, copyKey) => {
      const value = unparsedCopy[copyKey];
      if (isEmpty(value)) {
        return copy;
      }
      copy[copyKey] = isObject(value) ? value.value : value;
      return copy;
    }, {});
    return memo;
  }, {});
}
function createAction(name) {
  return `@@legalConsent/${name}`;
}
export const REQUEST_SUBSCRIPTION_DEFINITIONS = createAction('REQUEST_SUBSCRIPTION_DEFINITIONS');
export const RETRIEVED_SUBSCRIPTION_DEFINITIONS = createAction('RETRIVED_SUBSCRIPTION_DEFINITIONS');
export const FAIL_RETRIEVED_SUBSCRIPTION_DEFINITIONS = createAction('FAIL_RETRIVED_SUBSCRIPTION_DEFINITIONS');
export const REQUEST_CONSENT_COPY = createAction('REQUEST_CONSENT_COPY');
export const RETRIEVED_CONSENT_COPY = createAction('RETRIEVED_CONSENT_COPY');
export const FAIL_RETRIEVED_CONSENT_COPY = createAction('FAIL_RETRIEVED_CONSENT_COPY');
export function requestSubscriptionDefinitions({
  businessUnitId
} = {}) {
  return {
    type: REQUEST_SUBSCRIPTION_DEFINITIONS,
    businessUnitId
  };
}
export function retrivedSubscriptionDefinitions(definitions) {
  return {
    type: RETRIEVED_SUBSCRIPTION_DEFINITIONS,
    definitions
  };
}
export function failSubscriptionDefinitions() {
  return {
    type: FAIL_RETRIEVED_SUBSCRIPTION_DEFINITIONS
  };
}
export function requestConsentCopy() {
  return {
    type: REQUEST_CONSENT_COPY
  };
}
export function retrivedConsentCopy(consentCopy) {
  return {
    type: RETRIEVED_CONSENT_COPY,
    consentCopy
  };
}
export const failRetrivedConsentCopy = () => ({
  type: FAIL_RETRIEVED_CONSENT_COPY
});
export const getSubscriptionDefinitions = ({
  businessUnitId = ACCOUNT_BUSINESS_UNIT_ID,
  hasBusinessUnitsAccess = false,
  isUngatedForCampaignBusinessUnit = false
} = {}) => (dispatch, getState) => {
  // Check if definitions already in store
  const maybeDefinitions = getSubscriptionDefinitionsFromSelector(getState());
  if (!isEmpty(maybeDefinitions)) {
    return Promise.resolve();
  }

  // Fetch definitions from store
  dispatch(requestSubscriptionDefinitions());
  return fetchSubscriptionDefinitionsByBusinessUnitId({
    businessUnitId,
    hasBusinessUnitsAccess,
    isUngatedForCampaignBusinessUnit
  }).then(definitions => {
    dispatch(retrivedSubscriptionDefinitions({
      subscriptionDefinitions: definitions
    }));
  }).catch(() => {
    dispatch(failSubscriptionDefinitions());
  });
};
export const getDefaultCopyForLegalConsent = () => dispatch => {
  dispatch(requestConsentCopy());
  return addDefaultConsentCopy({}).then(({
    consentCopy
  }) => {
    const parsedValues = _parseValuesFromConsentCopy(consentCopy);
    dispatch(retrivedConsentCopy(parsedValues));
  }).catch(() => {
    dispatch(failRetrivedConsentCopy());
  });
};